import Navbar from "./components/NavBar/Navbar.jsx";
import Home from "./components/Home/Home.jsx";
import About from "./components/About/About.jsx";
import Academics from "./components/Academics/Academics.jsx";
import Work from "./components/Work/Work.jsx";
import Service from "./components/Service/Service.jsx";
import Contact from "./components/Contact/Contact.jsx";
import Footer from "./components/Footer/Footer.jsx";
function App() {
  return (
    <div className="App">
      < Navbar/>
      < Home />
      < About />
      < Academics />
      < Work />
      < Service />
      < Contact />
      < Footer />
    </div>
  );
}

export default App;
